export function createPendingSpellSaveContext({
  spell,
  entries = [],
  saveType = 'dex',
  saveDC = 10,
  conditionsToApply = [],
  bypassReaction = false,
  combatState = null,
  charsState = null,
  sourceKind = 'spell',
  sourceName = null,
  itemAbilityAuthority = null,
} = {}) {
  return {
    spell: spell || null,
    entries: Array.isArray(entries) ? [...entries] : [],
    saveType: saveType || 'dex',
    saveDC: Number.isFinite(saveDC) ? saveDC : 10,
    conditionsToApply: Array.isArray(conditionsToApply) ? [...conditionsToApply] : [],
    bypassReaction: !!bypassReaction,
    combatState: combatState || null,
    charsState: charsState || null,
    sourceKind: sourceKind || 'spell',
    sourceName: sourceName || spell?.name || null,
    itemAbilityAuthority: itemAbilityAuthority && typeof itemAbilityAuthority === 'object'
      ? { ...itemAbilityAuthority }
      : null,
  };
}

export function getPendingSpellSaveCombatState(pendingSpellSaveContext, liveCombatState) {
  return pendingSpellSaveContext?.combatState || liveCombatState;
}

export function getPendingSpellSaveCharsState(pendingSpellSaveContext, liveCharsState) {
  return pendingSpellSaveContext?.charsState || liveCharsState;
}
